// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/switch/style/index.less
// module id = 1814
// module chunks = 0